// frontend/src/config/queryClient.ts
import { QueryClient } from '@tanstack/react-query';

// IND-058: el único cliente de consultas de la app (el que usa main.tsx). Antes
// había otro aquí y los «queryClient.clear()» del cierre de sesión limpiaban
// ese, no el de la app: los datos del usuario anterior seguían en memoria.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
    mutations: {
      retry: 0, // No reintentar mutaciones por defecto
    },
  },
});

export default queryClient;
